import { useQueries } from "@tanstack/react-query";
import apiClient from "lib/api-client";

const fetchCategorySizes = async (categoryName) => {
  const res = await apiClient.get(`/api/v3/client/vision_order/getCategorySizeList/${categoryName}`);
  return res.data.sizes;
};

const useCategorySizes = (categoryNames = []) => {
  const results = useQueries({
    queries: categoryNames.map((categoryName) => ({
      queryKey: [`item-sizes-${categoryName}`],
      queryFn: () => fetchCategorySizes(categoryName),
      // staleTime: 1000 * 60 * 5,
      enabled: true,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
    })),
  });

  const isLoading = results.some((r) => r.isLoading);
  const isError = results.some((r) => r.isError);
  const isFetch = results.some((r) => r.isFetching);

  const allSizeData = categoryNames.reduce((acc, category, i) => {
    acc[category] = results[i]?.data || [];
    return acc;
  }, {});

  return { allSizeData, isLoading, isError, isFetch };
};

export default useCategorySizes;
